import { FormControl } from '@angular/forms';
import { Type } from '@angular/core';

export enum ChatFormFieldType {
  Text = 'text',
  Reference = 'entityRef',
  DateTime = 'dateTime',
  Control = 'control',
  Hidden = 'hidden',
}

export enum ChatFormOperation {
  Create = 'create',
  Update = 'update',
  Read = 'read',
  Confirm = 'confirm',
}

export interface IChatFormField {
  name: string;
  description?: string;
  type: ChatFormFieldType;
  required: boolean;
  secret: boolean;
  referenceType?: string;
  isCascade?: boolean;
  valueDefault?: unknown;
  controlComponent?: Type<IChatFormControl>;
}

export interface IChatFormControl {
  control: FormControl<string>;
  required: boolean;
  contextChanged: (context: Record<string, string>) => void;
}

export interface IChatForm {
  entity: string;
  operation: ChatFormOperation;
  fields: IChatFormField[];
  values?: Record<string, unknown>;
  valuesPending?: Record<string, unknown>;
  comment?: string;
  commentPending?: string;
  isSubmitting?: boolean;
}

export interface IChatFormResolvedEvent {
  values?: Record<string, unknown>;
  comment?: string;
}
